<ng-container *ngIf="(isLoggedWithOpenCaraibe$ | async) === false || isEligibleEntryForOpenCaraibe()">
  <a
    class="ob1-link-icon carrousel-link-icon"
    [ngClass]="{ 'carrousel-active-link': selected }"
    (click)="openLink(carrouselItemLinkButton.hrefLink, type); (false)"
    [href]="carrouselItemLinkButton.hrefLink"
    [attr.aria-current]="selected ? true : null"
  >
    <span
      class="carrousel-link-text"
      [ngClass]="{ 'carrousel-active-link-text': selected }"
      [innerHTML]="carrouselItemLinkButton.label"
    ></span>
    <ng-container *ngIf="contactInfos && (hasInvalidContactMeans$ | async)">
      <span class="icon icon-Warning-important carrousel-pos-link-icon" aria-hidden="true"></span>
    </ng-container>
  </a>
</ng-container>
